import useSWR from 'swr';
import { API_HOST } from '../helpers/constants';
import { fetcher } from '../utils';

export function useBlock(id) {
  const url = `${API_HOST}/blocks/${id}`;

  const { data: responseData, error, isLoading, mutate } = useSWR(id ? url : null, fetcher);

  const revalidate = () => mutate(url);

  return {
    block: responseData,
    isLoading,
    isError: error,
    revalidate
  };
}
